module.exports = {
  ConfigureDisplayColumns: 'Настройка отображаемых столбцов',
  AllNames: 'Все названия',
  SelectedColumns: 'Выбранные столбцы',
  YouToViewSecondaryInformation: 'У вас нет прав для просмотра информации вторичной таблицы!',
  Yes: 'Да',
  WorkflowNumber: 'Рабочий номер',
  YouToSetSecondaryColumns: 'У вас нет прав на настройку отображаемых столбцов вторичной таблицы!',
  CancelCounting: 'Отменить подсчет'
}
